// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import AddressInfoDisplay from "@insite/content-library/Components/AddressInfoDisplay";
import Typography from "@insite/mobius/Typography";
import { addressProps } from "@store/Themes/common/props/address";
import { AddressInfo } from "@store/Library/Widgets/BillingShippingInfo";
import { horizontalStyles } from "@store/Overrides/Widgets/Cart/CartFulfillmentMethodSelector";
import React from "react";

interface Props {
    addressInfo: AddressInfo;
    headline: string;
}

const AddressInfoDisplayWithHeader = ({ addressInfo, headline }: Props) => {
    const styles = horizontalStyles;
    return (
        <StyledWrapper
            {...styles.pickUpLocation?.wrapper}
            data-test-selector={`address_info_display_with_header_${headline}`}
        >
            <Typography {...addressProps.title} data-test-selector="cart_warehouseName">
                {headline}
            </Typography>
            <AddressInfoDisplay {...addressInfo} />
        </StyledWrapper>
    );
};

export default AddressInfoDisplayWithHeader;
